<template>
	<el-drawer title="下单明细" :visible.sync="drawerShow" :wrapperClosable="true" :destroy-on-close="true" size="100%"
		@close="close" v-loading="dataLoading">
		<div class="drawer-content">
			<div class="page-list-box">
				<el-table :data="details" border style="width: 100%" v-loading="dataLoading" size="small" stripe>
					<el-table-column prop="createUserName" label="下单用户">
					</el-table-column>
					<el-table-column prop="createUser" label="用户id">
					</el-table-column>
					<el-table-column prop="name" label="渠道">
					</el-table-column>
					<el-table-column prop="paidTime" label="支付时间" min-width="150" show-overflow-tooltip>
					</el-table-column>
					<el-table-column prop="saleAmount" label="订单金额">
					</el-table-column>
					<el-table-column prop="orderSn" label="订单编号">
					</el-table-column>
					<el-table-column prop="commission" label="渠道佣金百分比">
					</el-table-column>
					<el-table-column prop="commissionAmount" label="佣金">
					</el-table-column>					
				</el-table>
			</div>
		</div>
		<div class="drawer-footer">
			<el-button @click="close">关闭</el-button>
		</div>
	</el-drawer>
</template>
<script>
	export default {
		components: {},
		data() {
			return {
				dataLoading: false,
				drawerShow: false,
				details: []
			}
		},
		methods: {
			close() {
				this.drawerShow = false;
			},
			show(data) {
				if (data) {
					this.data = data
					this.getData()
				}

				this.drawerShow = true;
			},
			getData() {
				this.dataLoading = true;
				this.$request({
						url: "/track/management/data/detail",
						method: "POST",
						params: {
							id: this.data.id
						},
					})
					.then((res) => {
						const {
							state,
							msg,
							result
						} = res.data;
						if (state == 1 && result) {
							this.details = result;

						} else {
							this.$message.error(msg || "请求失败");
						}
					})
					.finally(() => {
						this.dataLoading = false;
					});
			},



		}
	}
</script>

<style lang="scss" scoped>
	::v-deep .el-drawer {
		max-width: 90%;
	}

	.font10 {
		font-size: 10px;
	}

	.tdc {
		font-size: 16px;
		font-weight: bold;
	}

	.shortUrl {
		margin-top: 15px;
	}

	.url {
		margin-top: 5px;
		color: #999
	}

	::v-deep .el-card__body {
		padding: 10px
	}

	.auditTotalNum {
		margin-top: 20px;

		.title {

			font-weight: bold;

			small {
				color: #999
			}
		}

		.num {
			margin-top: 10px;
			color: #999;

			.color-danger {
				font-size: 18px;
			}

			.color-blue {
				font-size: 14px;
			}
		}
	}

	.copyTool {
		opacity: 0;
		filter: alpha(opacity=0);
		// height: 1px;
	}

	.card-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
</style>